import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type JiraProjectType,
	type specialOfferSixtyModalQuery,
} from './__generated__/specialOfferSixtyModalQuery.graphql';
import type { SpecialOfferSixtyModalProps } from './special-offer-sixty-modal';

export type EntryPointParams = {
	cloudId: string;
	projectType: JiraProjectType;
};

export const entryPoint: EntryPoint<
	EntryPointComponent<
		{
			specialOfferSixtyModalQuery: specialOfferSixtyModalQuery;
		},
		Record<string, never>,
		SpecialOfferSixtyModalProps,
		Record<string, never>
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-special-offer-sixty-modal" */ './special-offer-sixty-modal'
			),
		{
			moduleId: 'edition-awareness-special-offer-sixty-modal',
		},
	),
	getPreloadProps: ({ cloudId, projectType }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			specialOfferSixtyModalQuery: {
				parameters,
				variables: {
					cloudId,
					projectType,
				},
			},
		},
	}),
});
